import React from 'react';
import styled from '@emotion/styled';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { queryHelper, nodeHelper } from 'helpers';
import { Link } from 'gatsby';
// import icons
import AnimateCard from './AnimateCard';
import BuyIcon from '/static/icons/nav/cart.svg';

/*
    import Image from 'gatsby-image';
    {(imgProps.fluid || imgProps.fixed) && // Legacy Image Processing
            <Image {...imgProps} className="img" />}
*/

const Wrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .hit-title {
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
    > label {
      color: ${({theme}) => theme.colors.black};
    }
  }`

const PhotoCard = ({children, slug, imgProps, size}) => {
  return (
    <Wrapper to={slug}>
      <AnimateCard
        width = {
          size === 'large' ?
            `${imgProps.fixed ? imgProps.fixed.width : 380}px`
            : `${imgProps.fixed ? imgProps.fixed.width : 155}px`
        }
        height = {
          size === 'large' ?
          `${imgProps.fixed ? imgProps.fixed.height : 221}px`
          : `${imgProps.fixed ? imgProps.fixed.height : 221}px`
        }
      >
        <div className="img-wrapper">
          {(imgProps.gatsbyImage) && // New Image Processing https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-plugin-image/#gatsbyimage
            <GatsbyImage image={getImage(imgProps.gatsbyImage)} alt={imgProps.alt} className="img" />}
          {imgProps.src &&
            <img {...imgProps} className="img" />
          }
        </div>
        {!children &&
          <div className="info">
            <span>
              <BuyIcon />
              <label>Buy</label>
            </span>
          </div>
        }
      </AnimateCard>
      <div className="hit-title">
        {children}
      </div>
    </Wrapper>
  );
}

export default PhotoCard;